export default __webpack_public_path__ + "static/media/arrow.94b44606.svg";